import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";

export const bookingsApiSlice = createApi({
  reducerPath: "bookingsApiSlice",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["bookingSummary", "verifyPaymnetParcel", "openDoorParcelRetrieval"],
  endpoints: (builder) => ({
    getUserOrder: builder.query({
      query: ({ orderIds }) => {
        return {
          url: `/orders/${orderIds}?include-group=true&createdBy=any`,
        };
      },
      providesTags: ["bookingSummary"],
    }),
    openDoorParcelRetrieval: builder.mutation({
      // Corrected to accept data as argument and use POST method
      query: (reservationId: string) => {
          return {
              url: `/open/door/parcel/retrieval`,
              method: "POST",
              data: {
                reservationIds: [reservationId] 
              },
          };
      },
      invalidatesTags: ["verifyPaymnetParcel"], // Assumed you want to invalidate locationList on create
    }),
    verifyPayment: builder.query({
      query: ({ reservationId }) => {
        return {
          url: `/parcel/retrieval/${reservationId}`,
        };
      },
      providesTags: ["openDoorParcelRetrieval"],
    }),
  }),
});

export const { useGetUserOrderQuery, useLazyGetUserOrderQuery, useVerifyPaymentQuery, useOpenDoorParcelRetrievalMutation } =
  bookingsApiSlice;
